import React, { useEffect } from 'react';
import './Hero.scss';

const Hero = () => {
  useEffect(() => {
    // Hero Parallax Mouse Effect - Orijinal script.js'ten
    const heroSection = document.querySelector('.hero');
    const heroBackground = document.querySelector('.hero .hero-background-image');
    const heroContainer = document.querySelector('.hero .container');

    if (heroSection && heroBackground && heroContainer) {
      const handleMouseMove = (e) => {
        const x = e.clientX / window.innerWidth;
        const y = e.clientY / window.innerHeight;
        
        // Background image parallax - birebir aynı formül
        heroBackground.style.transform = `translate(${(x - 0.5) * 50}px, ${(y - 0.5) * 25}px)`;
        heroContainer.style.transform = 'translate(0px, 0px)';
      };

      const handleMouseLeave = () => {
        // Mouse çıkınca geri dönsün
        heroBackground.style.transition = 'transform 0.5s ease-out';
        heroBackground.style.transform = 'translate(0px, 0px)';
        heroContainer.style.transform = 'translate(0px, 0px)';
        
        // Transition'ı geri normal hale getir
        setTimeout(() => {
          heroBackground.style.transition = 'transform 0.1s linear';
        }, 500);
      };

      // Event listener'ları ekle
      heroSection.addEventListener('mousemove', handleMouseMove);
      heroSection.addEventListener('mouseleave', handleMouseLeave);

      // Cleanup function
      return () => {
        heroSection.removeEventListener('mousemove', handleMouseMove);
        heroSection.removeEventListener('mouseleave', handleMouseLeave);
      };
    }

    // Keşfet butonu artık header'daki smooth scroll sistemi tarafından otomatik yakalanacak
    // çünkü href="#bizkimiz" linki var
  }, []);

  return (
    <section className="hero">
      <img src="images/hero-bg.png" alt="Hero Background" className="hero-background-image" />
      <div className="container">
        <div className="hero-content" data-aos="fade-up" data-aos-delay="200">
          <h1>Finansal Teknolojiler Alanında Yenilikçi İş Modellerimiz ve Akıllı Çözümlerimizle İlerliyoruz!</h1>
        </div>
        <a href="#bizkimiz" className="scroll-down">
          <div className="scroll-icon">
            <img src="icons/scrool.svg" alt="Aşağı Kaydır" />
          </div>
          <span>Keşfet</span>
        </a>
      </div>
    </section>
  );
};

export default Hero;
